import { Controller } from "@hotwired/stimulus"

// Mobile drawer for the admin sidebar. On lg+ the panel is always visible (CSS).
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  toggle() {
    this.open = !this.open
  }

  close() {
    this.open = false
  }

  set open(value) {
    this.panelTarget.classList.toggle("-translate-x-full", !value)
    if (this.hasBackdropTarget) this.backdropTarget.classList.toggle("hidden", !value)
    this.element.dataset.sidebarOpen = value
  }

  get open() {
    return this.element.dataset.sidebarOpen === "true"
  }
}
